module.exports = __webpack_public_path__ + "h5/img/handsel_1.2f948eec.jpg";